/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-17 10:58:18
 * @LastEditors: K
 * @LastEditTime: 2022-05-23 13:40:03
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import * as S from '../../services/ReplaceMakeOrganization'

//  代煎机构列表
export const getReplaceMakeOrganizationList = createAsyncThunk<
  any,
  S.ReplaceMakeOrganizationParams,
  RootThunkApi
>('stand/getReplaceMakeOrganizationList', async (params, api) => {
  return sendAsync(S.ReplaceMakeOrganizationList(params), api)
})

// 代煎状态切换
export const isChangeOrganizationStatus = createAsyncThunk<
  any,
  S.changeOrganizationStatusParams,
  RootThunkApi
>('stand/isChangeOrganizationStatus', async (body, api) => {
  return sendAsync(S.changeOrganizationStatus(body), api)
})

// 新增/修改合作饮片厂的模糊查询
export const getOrganizationPartnerName = createAsyncThunk<
  any,
  S.OrganizationPartnerNameParams,
  RootThunkApi
>('stand/isChangeOrganizationStatus', async (body, api) => {
  return sendAsync(S.OrganizationPartnerName(body), api)
})

// 获取合作饮片厂列表
export const getOrganizationPartnerList = createAsyncThunk<
  any,
  S.OrganizationPartnerListParams,
  RootThunkApi
>('stand/isChangeOrganizationStatus', async (body, api) => {
  return sendAsync(S.OrganizationPartnerList(body), api)
})
